"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react2 = require("@emotion/react");
var _Form = _interopRequireDefault(require("../../hocs/Form"));
var _Alert = _interopRequireDefault(require("../../molecules/Alert"));
var _ts = require("../../ts");
var _ImageInput = _interopRequireDefault(require("./ImageInput"));
var _ImageDisplay = _interopRequireDefault(require("./ImageDisplay"));
var _ImageCropper = _interopRequireDefault(require("./ImageCropper"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  name: '',
  shape: _ts.UIElementShapeEnum.Rect,
  labels: {
    loadInputText: '',
    loadButtonText: '',
    saveCropButtonText: '',
    cancelCropButtonText: ''
  },
  size: {
    width: 275,
    height: 275
  },
  defaultImage: '',
  onSubmit() {},
  loadingOnSubmit: false,
  onDelete() {},
  loadingOnDelete: false,
  helperTexts: [],
  hidden: false
};
function ImageUploader(props) {
  var _errors$name2, _errors$name3;
  const {
    name,
    shape,
    labels,
    defaultImage,
    size,
    onSubmit,
    loadingOnSubmit,
    onDelete,
    loadingOnDelete,
    helperTexts
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const {
    formState: {
      errors
    },
    setValue,
    reset,
    watch,
    trigger
  } = _Form.default.useForm();
  const hiddenInputRef = (0, _react.useRef)(null);
  const handleOnCancel = (0, _react.useCallback)(() => {
    setValue(name, null);
    setValue('editing', false);
    if (hiddenInputRef !== null && hiddenInputRef !== void 0 && hiddenInputRef.current) hiddenInputRef.current.value = '';
  }, [name, hiddenInputRef, defaultImage]);
  const handleOnLoad = (0, _react.useCallback)(() => {
    var _hiddenInputRef$curre;
    return hiddenInputRef === null || hiddenInputRef === void 0 || (_hiddenInputRef$curre = hiddenInputRef.current) === null || _hiddenInputRef$curre === void 0 ? void 0 : _hiddenInputRef$curre.click();
  }, [hiddenInputRef]);
  const handleOnChangeImage = (0, _react.useCallback)(event => {
    const {
      files
    } = (event === null || event === void 0 ? void 0 : event.target) || {};
    if (!(files !== null && files !== void 0 && files[0])) return;
    setValue(name, files);
    trigger('image').then(isValid => {
      if (isValid) setValue('editing', true);
    });
  }, [trigger, setValue, name]);
  const isEditing = (0, _react.useMemo)(() => watch('editing'), [watch('editing')]);
  const hasError = (0, _react.useMemo)(() => {
    var _errors$name;
    return Boolean(errors === null || errors === void 0 || (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message);
  }, [errors === null || errors === void 0 ? void 0 : errors[name]]);
  const alertStyles = (0, _react.useMemo)(() => cssAlertStyles(size === null || size === void 0 ? void 0 : size.width), [size === null || size === void 0 ? void 0 : size.width]);
  (0, _react.useEffect)(() => {
    return () => {
      reset();
      if (hiddenInputRef !== null && hiddenInputRef !== void 0 && hiddenInputRef.current) hiddenInputRef.current.value = '';
    };
  }, [defaultImage, name]);
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(CustomDashedBorder, {
    size: size,
    hidden: Boolean(defaultImage && !isEditing)
  }, /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 100 100"
  }, shape === _ts.UIElementShapeEnum.Round ? /*#__PURE__*/_react.default.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "50",
    stroke: "white",
    strokeWidth: "1",
    fill: "none",
    strokeDasharray: "5"
  }) : /*#__PURE__*/_react.default.createElement("rect", {
    x: "0",
    y: "0",
    width: "100",
    height: "100",
    rx: "3",
    ry: "3",
    stroke: "white",
    strokeWidth: "1",
    fill: "none",
    strokeDasharray: "5",
    strokeDashoffset: "3"
  }))), defaultImage && !isEditing ? /*#__PURE__*/_react.default.createElement(_ImageDisplay.default, {
    image: defaultImage,
    shape: shape,
    size: size,
    loadingOnDelete: loadingOnDelete,
    loadingOnSubmit: loadingOnSubmit,
    helperTexts: helperTexts,
    onDelete: onDelete,
    onLoad: handleOnLoad,
    buttonText: labels === null || labels === void 0 ? void 0 : labels.loadButtonText
  }) : isEditing ? /*#__PURE__*/_react.default.createElement(_ImageCropper.default, {
    name: name,
    shape: shape,
    size: size,
    nextButtonText: labels === null || labels === void 0 ? void 0 : labels.saveCropButtonText,
    cancelButtonText: labels === null || labels === void 0 ? void 0 : labels.cancelCropButtonText,
    loading: loadingOnSubmit,
    handleSubmit: onSubmit,
    handleOnCancel: handleOnCancel
  }) : /*#__PURE__*/_react.default.createElement(_ImageInput.default, {
    size: size,
    shape: shape,
    inputLabel: labels.loadInputText,
    helperTexts: helperTexts,
    onLoad: handleOnLoad
  }), /*#__PURE__*/_react.default.createElement(_Alert.default, {
    show: hasError,
    type: _ts.UIElementStatusEnum.Error,
    title: errors === null || errors === void 0 || (_errors$name2 = errors[name]) === null || _errors$name2 === void 0 ? void 0 : _errors$name2.type,
    description: errors === null || errors === void 0 || (_errors$name3 = errors[name]) === null || _errors$name3 === void 0 ? void 0 : _errors$name3.message,
    styles: alertStyles
  }), /*#__PURE__*/_react.default.createElement(HiddenInputFilePicker, {
    type: "file",
    name: name,
    accept: "image/*",
    onChange: handleOnChangeImage,
    ref: hiddenInputRef
  }));
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n"])));
const CustomDashedBorder = _styled.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  pointer-events: none;\n  border-radius: 50%;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 1;\n\n  svg {\n    width: 100%;\n    height: 100%;\n    transform: rotate(90deg);\n  }\n\n  ", "\n"])), _ref => {
  let {
    size,
    hidden
  } = _ref;
  return "\n    width: ".concat(size.width, "px;\n    height: ").concat(size.height, "px;\n\n    opacity: ").concat(hidden ? 0 : 1, ";\n  ");
});
const HiddenInputFilePicker = _styled.default.input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: none;\n"])));
const cssAlertStyles = maxWidth => (0, _react2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  max-width: ", "px;\n  background-color: transparent;\n  margin-top: 25px;\n"])), maxWidth);
var _default = exports.default = ImageUploader;